export default __webpack_public_path__ + "static/media/Kiss.9639f60e.svg";